import _includes from "lodash/includes";
import _startsWith from "lodash/startsWith";
import _get from "lodash/get";
import { authenticateWithGoogle, authenticateWithApple, authenticateWithCorpIdp, register, signin, signinWithOneTimeToken, signinWithRefreshToken, signout, softSignout } from "../actions/auth";
var AUTHENTICATE_ACTION_TYPES = [signin.SUCCESS_TYPE, signinWithOneTimeToken.SUCCESS_TYPE, register.SUCCESS_TYPE, authenticateWithGoogle.SUCCESS_TYPE, authenticateWithApple.SUCCESS_TYPE, authenticateWithCorpIdp.SUCCESS_TYPE, signinWithRefreshToken.SUCCESS_TYPE];
/*
 * @returns {Boolean} whether an Identity request failed on account of *missing* authentication (as
 * opposed to other causes of authentication failure)
 */

export var identityRequestMissingAuth = function identityRequestMissingAuth(action) {
  var resp = _get(action, 'meta.resp.resp');

  return _startsWith(_get(resp, 'url', ''), process.env.IDENTITY_BASE_URL) && _get(resp, 'statusCode') === 401 && _get(resp, 'body.error.data.user_is_logged_out');
};
/*
 * @returns {Boolean} whether an action resulted in the user becoming authenticated
 */

export var isAuthenticateAction = function isAuthenticateAction(action) {
  return _includes(AUTHENTICATE_ACTION_TYPES, action.type);
};
/*
 * @returns {Boolean} whether an action resulted in the user becoming unauthenticated
 */

export var isUnauthenticateAction = function isUnauthenticateAction(action) {
  return action.type === signout.SUCCESS_TYPE || action.type === softSignout.getType() || identityRequestMissingAuth(action);
};